import { useParams } from 'react-router-dom';
import { Card } from '@client/toolkit';
import { PageContentAnimation } from '../../../../components/layout';
import { InvoiceOverview } from '../../../../components/invoice-overview';

export function CompanyInvoicesTab() {
  const { id } = useParams<{ id: string }>();

  return (
    <PageContentAnimation>
      <Card>
        <InvoiceOverview companyId={id} autoFetch />
      </Card>
    </PageContentAnimation>
  );
}
